// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"7bf568b0","128":"11196204","163":"767c8d8a","199":"cac11291","237":"2d097bf0","243":"9f455111","317":"eb20a408","336":"f2dec7c8","425":"42d04053","828":"991baf3e","861":"36fb874b"}[chunkId] + ".chunk.js";
};